import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { IoDrug, NamedThing, IoDrugGroup, IoDiagnosis } from '../../types';
import _ from "lodash";
import { DrugDetailPage } from '../drug-detail/drug-detail';
import { DrugDataStore } from '../../providers/data/drug-data-store';

/**
	* Generated class for the AdvancedSearchPage page.
	*
	* See https://ionicframework.com/docs/components/#navigation for more info on
	* Ionic pages and navigation.
	*/

@IonicPage()
@Component({
	selector: 'page-advanced-search',
	templateUrl: 'advanced-search.html',
})
export class AdvancedSearchPage {

	dropdownSettings = {
		singleSelection: false,
		idField: 'id',
		textField: 'name',
		selectAllText: 'Select All',
		unSelectAllText: 'UnSelect All',
		itemsShowLimit: 5,
		allowSearchFilter: true,
		closeDropDownOnSelection: true,
	};

	allGroups: Array<IoDrugGroup> = [];
	allDiagnoses: Array<IoDiagnosis> = [];

	groupSetMode: "merge" | "intersect" = "intersect";
	diagnosisSetMode: "merge" | "intersect" = "intersect";

	includedGroups: Array<{ id: number }> = [];
	excludedGroups: Array<{ id: number }> = [];

	includedDiagnoses: Array<{ id: number }> = [];
	excludedDiagnoses: Array<{ id: number }> = [];

	filteredDrugs: Array<IoDrug> = [];
	diagnosesOfFilteredDrugs: Array<{ name: string, count: number }> = [];
	groupsOfFilteredDrugs: Array<{ name: string, count: number }> = [];

	prefilter: 'drugs' | 'groups' | 'diagnoses' = 'drugs';

	constructor(public navCtrl: NavController, public navParams: NavParams, public dds: DrugDataStore) {
		this.allDiagnoses = dds.getAllDiagnoses();
		this.allGroups = dds.getAllGroups();
	}

	ionViewDidLoad() {
	}

	onItemSelect(item: any) {
		this.filterDrugs();
	}

	onSelectAll(e: Event) {
		this.filterDrugs();
	}

	onPrefilterChange(e: Event) {
		this.updateAggregations();
	}

	filterDrugs() {
		const getDrugsOfGroupById = (id: number) => {
			return this.dds.getDrugsOfGroup(this.dds.getGroupById(id));
		}

		const groupSetFunction = this.groupSetMode === "intersect"
			? _.intersection
			: _.union;
		const drugsInSelectedGroups = this.includedGroups.length
			? groupSetFunction(...this.includedGroups.map(g => getDrugsOfGroupById(g.id)))
			: this.dds.getAllDrugs();
		var result: Array<IoDrug> = drugsInSelectedGroups;
		const drugsExcludedByGroups = _.union(...this.excludedGroups.map(g => getDrugsOfGroupById(g.id)));
		_.pullAll(result, drugsExcludedByGroups);

		const includedDiagnoses = this.includedDiagnoses.map(d => this.dds.getDiagnosisById(d.id));
		const excludedDiagnoses = this.excludedDiagnoses.map(d => this.dds.getDiagnosisById(d.id));

		result = result.filter(d => {
			const diagnosis = this.dds.getEffectsOfDrug(d).map(e => this.dds.getDiagnosisOfEffect(e));
			const inSetTestLength = this.diagnosisSetMode === "intersect"
				? includedDiagnoses.length
				: 1;
			return _.intersection(diagnosis, includedDiagnoses).length == inSetTestLength
				&& _.intersection(diagnosis, excludedDiagnoses).length == 0;
		});

		this.filteredDrugs = result.filter(d => !d.isTrademark);
		this.updateAggregations();
	}

	updateAggregations() {
		switch (this.prefilter) {
			case "drugs":
				return;
			case "groups":
				return this.aggregateGroups();
			case "diagnoses":
				return this.aggregateDiagnoses();
		}
	}

	aggregateGroups() {
		this.groupsOfFilteredDrugs = aggregateDrugRelations(this.filteredDrugs, d => this.dds.getGroupsOfDrug(d));
	}

	aggregateDiagnoses() {
		this.diagnosesOfFilteredDrugs = aggregateDrugRelations(this.filteredDrugs, d => this.dds.getEffectsOfDrug(d).map(e => this.dds.getDiagnosisOfEffect(e)));
	}

	drugClicked(drug) {
		this.navCtrl.push(DrugDetailPage, [drug]);
	}

}

function aggregateDrugRelations(drugs: Array<IoDrug>, selector: (d: IoDrug) => NamedThing[]) {
	const groupedByName = _.groupBy(_.flatMap(drugs, selector), "name");
	const nameCountPairs = _.toPairs(groupedByName).map(pair => ({ name: pair[0], count: pair[1].length }));
	const orderedNameCountPairs = _.orderBy(nameCountPairs, "count", "desc");
	return orderedNameCountPairs;
}


// WEBPACK FOOTER //
// ./src/pages/advanced-search/advanced-search.ts